import { useContext, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { UserContext } from '../context/userContext';
import { wpFetch } from 'src/helpers/wpApiHandler';

export const ForceLogin = () => {
  const { setUser, setIsLoggedIn } = useContext(UserContext);
  const navigate = useNavigate();
  const { tokenSlug } = useParams();
  console.log(tokenSlug);

  useEffect(() => {
    const authorizeAndFetchCompany = async () => {
      try {
        const companyId = await wpFetch(['authorization-check', tokenSlug], {
          method: 'POST',
        });

        const companyData = await wpFetch(['company', companyId], {
          method: 'GET',
        });

        localStorage.setItem('user', JSON.stringify(companyData));
        setUser(companyData);
        setIsLoggedIn(true);
        const checkUser = localStorage.getItem('user');
        console.log(companyData, 'what is this data');
        console.log(checkUser, 'what is this data');
      } catch (error) {
        console.error('An error occurred:', error);
        setUser(null);
      } finally {
        navigate('/dashboard/leads');
      }
    };

    if (tokenSlug) {
      authorizeAndFetchCompany();
    }
  }, [tokenSlug]);

  return null;
};
